import { modalLayer, getPlatform, toast, copyText, loadingLayer, getHistoryNew, defaultPhyCover, miniAppRouteTo } from '@utils'
import { memberMobx, memberCardMobx, storeMobx, locationMobx, themeMobx } from '@mobxStore'
import { MergeModal, BindVerifyModal, GuideModal, ContactType, SendInfoModal, AlertModal, TipModal, BindTipModal, TextTipAlert } from '@cps'
import { wxConfigG } from './third'
import { find } from '@dt/fe-utils/dist/lodash'
import MemberApi from '@api/member.api'
import { deepClone, localStore, getHandTopUrl } from '@dt/fe-utils'
const { isWeixin, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

export interface IWxAddressType {
  addressDetailInfoNew: string;
  addressStreetFourthStageName: string;
  cityName: string;
  countryName: string;
  detailInfo: string;
  errMsg: string;
  nationalCode: string;
  nationalCodeFull: string;
  postalCode: string;
  provinceName: string;
  telNumber: string;
  userName: string;
}
export default class MktController {
  constructor () { }
  private static _openWechat: boolean = false
  public static get openWechat () {
    return this._openWechat
  }
  public static set openWechat (bool: boolean) {
    this._openWechat = bool
  }
  // 获取分享模板
  private static getShareHtml (url: string, info: any) {
    const { brand } = storeMobx
    return `<div class="page-body" style="width: 100%">
     <div class="page-body" style="width: 100%; background: #fff; padding-top: 40px">
        <div class="brand-logo" style="width: 120px; margin: 0 auto">
            <img class="logo-img" style="display: block; width: 120px; height: 120px"
                src="${brand.logo}"
                alt="" />
        </div>
        <div class="body-content" style="width: 286px; padding: 48px 0 43px; margin: 0 auto">
            <div class="brand-info" 
            style="padding-bottom: 32px; border-bottom: 1px dashed #d8d7d5; text-align: center">
                <div class="brand-name" style="
              margin-bottom: 2px;
              font-size: 20px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #161616;
              line-height: 26px;
            ">
                ${brand.brandName}
                </div>
                <div class="card-type"
                    style="font-size: 12px; font-family: ArialMT; color: #656565; line-height: 16px">
                    ${i18n.t('mkt.market.activityShare')}
                </div>
            </div>
            <div class="message-info" style="padding: 40px 0 52px; text-align: center">
                <div class="hi-text" style="
              font-size: 14px;
              font-family: Arial-ItalicMT, Arial;
              font-weight: normal;
              color: #656565;
              line-height: 26px;
            ">
                    HI ${info.receivedPerson}
                </div>
                <div class="message-text" style="
              padding: 10px 0;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #161616;
              line-height: 26px;
            ">
                    " ${info.message} "
                </div>
                <div class="from-text" style="
              margin-bottom: 31px;
              font-size: 14px;
              font-family: Arial-ItalicMT, Arial;
              font-weight: normal;
              color: #656565;
              line-height: 26px;
            ">
                    From：${info.givePerson}
                </div>
                <a class="detail-btn" style="
              text-align: center;
              display: block;
              width: 286px;
              height: 48px;
              background: $themeColor;
              border-radius: 24px;
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ffffff;
              line-height: 48px;
              text-decoration: none;
            " href="${url}">${i18n.t('mkt.market.partInActive')}</a>
            </div>
            <div class="footer-info" style="text-align: center">
                <div style="
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #d0cabf;
              line-height: 16px;
            ">
                    eShine power
                </div>
            </div>
        </div>
    </div>
    </div>`
  }
  // 检查登录
  static checkLogin (history?: any, needLogin: boolean = true, needMember: boolean = true) {
    return new Promise<void>((resolve, reject) => {
      if (!memberMobx.isLogin && needLogin) {
        if (history) {
          history.push('/login')
        } else {
          reject()
        }
        return
      }
      if (memberMobx.memberInfo.type !== 'member' && needMember) {
        if (history) {
          this.jumpBind(history, 'all')
        } else {
          reject()
        }
        return
      }
      resolve()
    })
  }
  // 跳转绑定
  static jumpBind (history: any, bindType: 'all' | 'mobile' | 'email' | 'mobileRegister') {
    if (isWeixin && window.bo === 'cn' && bindType !== 'email') {
      if (isWeixinMiniProgram) {
        if (memberMobx.memberInfo.mobile) {
          history.push(`/iBind/${bindType}`)
        } else {
          const pathname: string = location.pathname.indexOf('iBind') > -1 ? '/my' : location.pathname
          let authPhoneUrl = `/pages/${bindType === 'mobileRegister' ? 'bindMobile' : 'authPhone'}/index?jumpH5Page=${location.origin + pathname}`
          if (Config.shareInfo) {
            authPhoneUrl = authPhoneUrl + '&shareInfo=' + Config.shareInfo
          }
          miniAppRouteTo(authPhoneUrl)
        }
      } else {
        history.push(`/iBind/${bindType}`)
      }
    } else {
      history.push(`/iBind/${bindType}`)
    }
  }
  // 返回
  public static goBack (history: any, path: string = '/my') {
    const routeInfo: any = history.getRouteInfo()
    if (routeInfo.id === '1') {
      if (isWeixinMiniProgram) {
        miniAppRouteTo('/pages/home/index')
      } else if (isAliPayMiniProgram) {
        miniAppRouteTo('/pages/home/index')
      } else {
        history.replace(path)
      }
    } else {
      if (routeInfo.routeDirection === 'none') {
        const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
        if (hasHome && hasHome.isShow !== 0) {
          if (isWeixinMiniProgram) {
            miniAppRouteTo('/pages/home/index')
          } else if (isAliPayMiniProgram) {
            miniAppRouteTo('/pages/home/index')
          } else {
            history.replace(path)
          }
        } else {
          history.replace(path)
        }
      } else {
        history.goBack()
      }
    }
  }
  // 广告位跳转会员卡
  static adToMemberCard (history: any, cardId: number) {
    if (!memberMobx.isLogin) {
      history.push('/login')
    } else {
      if (memberMobx.memberInfo.type !== 'member') {
        this.jumpBind(history, 'all')
      } else {
        const targeCard = find(memberMobx.cardList, (card) => card.cardId === cardId)
        if (targeCard) {
          const cardInfo = targeCard.card
          if (cardInfo.type === 'paid' && cardInfo.scales.length > 0 && targeCard.expireTime) {
            history.push('/iCard/cardOpen/buy/' + targeCard.memberCardId)
          } else if ((cardInfo.allowAgainLoad && cardInfo.recharges.length > 0) || cardInfo.allowCustomizeLoad) {
            history.push('/iCard/cardRecharge/' + targeCard.memberCardId)
          } else {
            history.push('/iCard/' + targeCard.cardId)
          }
        } else {
          history.push('/iCard/cardOpen/open/' + cardId)
        }
      }
    }
  }
  // 广告位
  static adToActive (history: any, url: string) {
    if (url.indexOf('https') !== -1) {
      if (url.indexOf('?') > -1) {
        window.location.href = `${url.slice(0, url.indexOf('?'))}?ct=${Config.codeType}&b=${Config.BRANDID}&s=${Config.STOREID}${Config.TABLECODE ? `&t=${Config.TABLECODE}` : ''}`
      } else {
        window.location.href = url
      }
    } else {
      history.push(url)
    }
  }
  // 广告位跳转活动预约详情
  static adToActivityReserve (history: any, activityId: number) {
    history.push(`/activityReserve/detail/${activityId}`)
  }
  // 广告位跳转积分兑换页
  static adToRedeem (history: any) {
    if (!memberMobx.isLogin) {
      history.push('/login')
    } else {
      history.push('/redeem')
    }
  }
  // 广告位跳转团购商城
  static adToGroupBuy (history: any) {
    if (!memberMobx.isLogin) {
      history.push('/login')
    } else {
      history.push('/groupBuy')
    }
  }
  // 广告位跳转礼品卡
  static adToGiftCard (history: any) {
    if (!memberMobx.isLogin) {
      history.push('/login')
    } else {
      history.push('/giftCard/2')
    }
  }
  // 初始化分享信息
  static initShareData (shareInfo?: {
    url: string;
    title: string;
    des?: string;
    img?: string;
  }) {
    console.log('mkt页面分享信息:________', shareInfo)
    if (isWeixin) {
      if (isWeixinMiniProgram) {
        this._openWechat = true
        wxConfigG.postMessage({
          type: 'shareInfo',
          shareInfo: {
            title: shareInfo.title || '',
            imageUrl: shareInfo.img || '',
            path: shareInfo.url,
          }
        })
      } else {
        wxConfigG.init(() => {
          wx.updateAppMessageShareData({
            title: shareInfo.title || '',
            desc: shareInfo.des || '',
            link: shareInfo.url,
            imgUrl: shareInfo.img || '',
            success: (res) => {
              this._openWechat = true
              console.log('updateAppMessageShareData_设置成功___', res)
            },
            fail: (error) => {
              console.log('updateAppMessageShareData_设置失败___', error)
            }
          })
        })
      }
    }
  }
  // 共享微信地址
  static openWxAddress () {
    return new Promise((resolve, reject) => {
      if (isWeixin) {
        wxConfigG.init((res: boolean) => {
          if (res) {
            wx.openAddress({
              success: function (addressRes) {
                console.log('openAddress:__', addressRes)
                resolve(addressRes)
              },
              fail: function (error: any) {
                reject(error)
              }
            })
          } else {
            reject()
          }
        })
      } else {
        reject()
      }
    })
  }
  // 赠券、赠卡跳转mmg分享地址
  static jumpMmgUrl (url: string, title: string, imageUrl?: string) {
    if (isWeixinMiniProgram) {
      const shareInfo = {
        title: title,
        path: `/pages/launch/index?jumpH5Page=${encodeURIComponent(url)}`,
        imageUrl: imageUrl || memberMobx.brandConfig?.shareImg || storeMobx.brand.logo || ''
      }
      const path: string = `/pages/launch/index?state=share&sharePageInfo=${encodeURIComponent(JSON.stringify({ mode: 'card', shareInfo: shareInfo }))}`
      window.wx?.miniProgram?.navigateTo({ url: path })
    } else {
      window.location.href = `${url}&pageType=share`
    }
  }
  static async jumpMiniGive (shareInfo: any, backUrl: string) {
    if (isWeixinMiniProgram) {
      const path: string = `/pages/launch/index?state=mktShare&sharePageInfo=${encodeURIComponent(JSON.stringify({ ...shareInfo, jumpH5Page: encodeURIComponent(backUrl) }))}`
      // let wxTemplateId = 46
      // try {
      //   wxTemplateId = (await MemberApi.findWxTemplateIdByBrandId(storeMobx.brand.brandId)).brandTemplateId
      // } catch (e) {}
      // if (wxTemplateId < 46) {
      //   path = `/pages/launch/index?state=share&sharePageInfo=${encodeURIComponent(JSON.stringify({ mode: 'card', shareInfo: shareInfo }))}`
      // }
      window.wx?.miniProgram?.navigateTo({ url: path })
    }
  }
  // 分享活动链接
  static shareUrl (url: string) {
    if (window.bo === 'cn') {
      if (isWeixin && this._openWechat) {
        modalLayer(GuideModal, null, 'GuideModal').then(() => { }).catch(() => { })
      } else {
        copyText(url || '')
        toast({ message: i18n.t('mkt.common.copyText') })
      }
    } else {
      modalLayer(ContactType, { title: i18n.t('mkt.market.shareMethod') }).then((type: any) => {
        modalLayer(SendInfoModal, { title: i18n.t('mkt.market.shareInfo'), type: type }).then(async (val: any) => {
          const shortRes: any = await MemberApi.getShortUrl(url)
          if (type === 'email') {
            MemberApi.sendEmail({
              nickName: val.givePerson,
              to: val.user,
              subject: i18n.t('mkt.market.activityShare'),
              html: this.getShareHtml(shortRes.shortUrl || url, val)
            }).then((res: any) => {
              modalLayer(AlertModal, {
                icon: 'icon-tab-my1_active',
                message: i18n.t('mkt.market.activityShareSucc')
              })
            })
          } else if (type === 'mobile') {
            MemberApi.sendSms({
              mobile: val.user,
              countryCode: val.countryCode,
              text: `${i18n.t('mkt.market.activityShare')}: ${shortRes.shortUrl || url}`,
            }).then((res: any) => {
              modalLayer(AlertModal, {
                icon: 'icon-tab-my1_active',
                message: i18n.t('mkt.market.activityShareSucc')
              })
            })
          }
        })
      })
    }
  }
  // 小程序绑定手机号
  static setWechatMiniappPhoneNumber (appId: string, authPhone: any, jsCode: string) {
    const authPhoneObj: any = JSON.parse(decodeURIComponent(authPhone))
    if (authPhoneObj?.type === 'merge') {
      setTimeout(() => {
        modalLayer(MergeModal, {
          info: {
            type: 'mobile',
            account: authPhoneObj.phoneNumber,
            countryCode: authPhoneObj.countryCode
          }
        }).then(() => {
          modalLayer(BindVerifyModal, {
            type: 'mobile',
            codeType: 'merge',
            account: authPhoneObj.phoneNumber,
            countryCode: `${authPhoneObj.countryCode}`
          }).then(() => {
            this.loginEnd()
          }, () => {
            this.loginEnd()
          })
        }, () => {
          this.loginEnd()
        })
      }, 500)
    } else {
      memberMobx.setWechatMiniappPhoneNumber({
        appId,
        encryptedData: authPhoneObj.encryptedData,
        iv: authPhoneObj.iv,
        jsCode,
      }).then((setRes: any) => {
        if (setRes.error) {
          modalLayer(MergeModal, {
            info: {
              type: 'mobile',
              account: setRes.data.phoneNumber,
              countryCode: setRes.data.countryCode
            }
          }).then(() => {
            modalLayer(BindVerifyModal, {
              type: 'mobile',
              codeType: 'merge',
              account: setRes.data.phoneNumber,
              countryCode: `${setRes.data.countryCode}`
            }).then(() => {
              this.loginEnd()
            }, () => {
              this.loginEnd()
            })
          }, () => {
            this.loginEnd()
          })
        } else {
          this.loginEnd()
        }
      })
    }
  }
  // 登录结束处理
  static async loginEnd (history?: any) {
    const bindGcInfo = localStore.get(memberMobx.bindGiftCardKey)
    if (bindGcInfo) {
      const para: any = {
        cardNo: bindGcInfo.cardNo,
        cardPin: bindGcInfo.cardPin
      }
      const res: any = await memberMobx.bindingGiftCard(para)
      if (res && !res.error) {
        modalLayer(BindTipModal, {
          cardNo: bindGcInfo.cardNo,
        }, 'bindTipModal').then(() => {
          localStore.remove(memberMobx.bindGiftCardKey)
          if (history) history.replace('/my')
        }, () => {
          window.location.href = `${getHandTopUrl()}/mmg/#/giftCard/${bindGcInfo.type}/${bindGcInfo.cardNo}/${bindGcInfo.ordersId}?b=${storeMobx.brand.brandId}&ct=brand`
          localStore.remove(memberMobx.bindGiftCardKey)
        })
      } else {
        localStore.remove(memberMobx.bindGiftCardKey)
        if (history) this.goBack(history)
      }
      return
    }
    const receiveInfo = localStore.get(memberMobx.receiveCouponKey)
    if (receiveInfo) {
      memberMobx.aquireMemberGiveCoupon(receiveInfo).then((res) => {
        if (res.error) {
          if (res.code === 4004) {
            localStore.remove(memberMobx.receiveCouponKey)
            if (history) this.goBack(history)
          } else {
            let text: string = ''
            if (res.code === 5001) {
              text = i18n.t('mkt.coupon.transferCancel')
            } else if (res.code === 5002) {
              text = i18n.t('mkt.coupon.couponReceived')
            }
            localStore.remove(memberMobx.receiveCouponKey)
            modalLayer(TipModal, {
              content: text
            }, 'tipModal').then(() => {
              if (history) history.replace('/my')
            })
          }
        } else {
          localStore.remove(memberMobx.receiveCouponKey)
          modalLayer(TipModal, {
            content: i18n.t('mkt.coupon.receivedSucc')
          }, 'tipModal').then(() => {
            if (history) history.replace('/my')
          })
        }
      })
      return
    }
    const consumeCouponsInfo = localStore.get(memberMobx.consumeCouponsKey)
    if (consumeCouponsInfo) {
      this.sendCoupons({
        ordersId: consumeCouponsInfo.ordersId,
        activityId: consumeCouponsInfo.activityId || ''
      }, history)
      return
    }
    if (history) this.goBack(history)
  }
  static sendCoupons (data: { ordersId: any; activityId?: any }, history?: any) {
    memberMobx.acquireByConsumeSendCoupon(data).then((res) => {
      if (res.error) {
        let text: string = ''
        let title = i18n.t('mkt.coupon.receivedFail')
        /**
         * 4004 订单不存在
         * 5009 已经领过
         * 4006 仅限下单人员扫码领取
         * 4002 不是会员
         * 4025 没有满足条件的活动
         * 5012 已经被自己领掉
         */
        if (res.code === 4025) {
          text = i18n.t('mkt.market.eventIsOver')
        } else if (res.code === 4002) {
          text = i18n.t('mkt.coupon.memberNoExit')
        } else if (res.code === 4004) {
          text = i18n.t('mkt.coupon.orderNoExit')
        } else if (res.code === 4006) {
          text = i18n.t('mkt.coupon.orderNotBuy')
        } else if (res.code === 5009) {
          text = i18n.t('mkt.coupon.redeemFail5')
        } else if (res.code === 5012) {
          title = ''
          text = i18n.t('mkt.coupon.receivedReset')
        } else { // 其他报错不做操作
          return
        }
        modalLayer(TextTipAlert, {
          title,
          des: text
        }, 'TextTipAlert').then(() => {
          if (res.code === 4002) {
            const history = getHistoryNew()
            if (history) this.jumpBind(history, 'all')
          } else {
            if (history) this.goBack(history)
            localStore.remove(memberMobx.consumeCouponsKey)
          }
        })
      } else {
        localStore.remove(memberMobx.consumeCouponsKey)
        modalLayer(TextTipAlert, {
          des: i18n.t('mkt.coupon.receivedSuccess')
        }, 'TextTipAlert').then(() => {
          if (history) this.goBack(history)
        })
      }
    })
  }
  // Open LBS
  static openLBS = (showLoading: boolean = true) => {
    return new Promise<void>((resolve, reject) => {
      showLoading && setTimeout(() => {
        loadingLayer.show()
      }, 100)
      // 获取定位
      if (locationMobx.locationIsOpen && locationMobx.location?.longitude && locationMobx.location?.latitude) {
        showLoading && setTimeout(() => {
          loadingLayer.hide()
        }, 100)
        resolve(locationMobx.location as any)
      } else {
        locationMobx.getLocation().then((location: any) => {
          showLoading && setTimeout(() => {
            loadingLayer.hide()
          }, 100)
          if (!(location?.latitude && location?.longitude)) {
            reject(location)
          } else {
            resolve(location)
          }
        })
      }
    })
  }
  // 卡列表封面
  static getGiftCardCover = (cardInfo: any) => cardInfo.cover || (cardInfo.type === 'physicalcard' ? cardInfo.giftcard.physicalcardCover : cardInfo.giftcard?.covers?.[0]?.url) || defaultPhyCover
  // 转增卡列表封面
  static getGiveGifCardCover = (cardInfo: any) => cardInfo.giveMemberCard?.cover || cardInfo.giftcard?.covers?.[0]?.url || defaultPhyCover
  // 检查是否壹向豆和微信小程序余额
  static checkMobileBindBalance = async (history: any) => {
    try {
      if (isWeixinMiniProgram) {
        const query = new URLSearchParams(location.search)
        const appId = query.get('appId') || window.Config.appId
        if (appId) { // 兼容 appId 获取不到的情况
          const res = await MemberApi.chcekWxAppMiniCoin(appId)
          if (res && res.all && Number(res.all) > 0) {
            this.jumpBind(history, 'all')
            return
          }
        } else {
          this.jumpBind(history, 'all')
          return
        }
      }
      const res = window.bo === 'cn' ? await MemberApi.chcekEshineCoin() : { valid: true }
      if (res.valid) {
        if (isWeixinMiniProgram) {
          this.jumpBind(history, 'mobileRegister')
        } else {
          this.jumpBind(history, 'all')
        }
      } else {
        toast({
          message: `${i18n.t('mkt.member.unableRegisterTip1')}<br/>${isWeixinMiniProgram ? i18n.t('mkt.member.unableRegisterTip2') : i18n.t('mkt.member.unableRegisterTip3')}`,
          time: 2000,
          position: 'middle',
          cssClass: 'toastW80'
        })
      }
    } catch (err) {
      console.error(err)
    }
  }
  // 从小到大排序等级卡
  static getSortedLevelList = (cardMap: any) => {
    return Object.values(cardMap).sort((a: any, b: any) => a?.level - b?.level) // 按成长值从小到大排序
  }
  // 判断某张卡是否是等级卡
  static checkIsLevelCard = (cardId: number) => {
    const { brandLevelCardMap, brandLevelOneCardIds } = memberCardMobx
    if (brandLevelOneCardIds.includes(cardId)) return cardId
    if (brandLevelCardMap[cardId]) return brandLevelCardMap[cardId]?.parentId
    return undefined
  }
  // 检查用户是否用购买团购商城的权限
  // 1.后台设置任何人，c端不做任何处理，都可购买
  // 2.后台设置卡
  //   2.1 c端用户无匹配，用户不可购买，隐藏购买入口，底部提示“您还不符合购买要求”
  //     2.1.1 后台设置卡中有普通卡，选择普通卡中的第一张卡，标签提示“限 XX 会员卡 用户购买”
  //     2.1.2 后台设置卡中只有等级卡
  //       2.1.2.1 用户有中间等级卡（不考虑中间等级卡是否可用）
  //         2.1.2.1.1 只有一张中间等级卡，优先选择离用户当前等级卡最近的更高等级卡，例如（优惠券关联A卡 LV1，LV2，LV5，LV6，用户拥有 LV3，则选择：A卡LV5）标签提示“限A卡 LV5 以上等级购买”（A卡 LV5 是相应等级卡的名称）
  //         2.1.2.1.2 有多张中间等级卡，每张中间等级卡按照 2.1.2.1.1 方法找出相应等级卡后取等级最高的，例如（有两张中间等级卡，A卡LV2 和 B卡LV1，优惠券关联的是 A卡 LV3，LV4，B卡关联的是LV5，LV6；则选择A卡LV3）（等级相同的话选默认匹配的第一张等级卡），标签提示“限B卡 LV6 以上等级购买”（B卡 LV6 是相应等级卡的名称）
  //       2.1.2.2 用户无中间等级卡，优先选择等级低的，例如（优惠券关联A卡 LV1，LV6；B卡关联LV2，LV3，则选择：A卡LV1），标签提示“限 A卡LV1 以上等级购买”（A卡 LV1 是相应等级卡的名称）（等级相同的话选默认匹配的第一张等级卡）
  //   2.2 c端用户有匹配
  //     2.2.1 匹配卡都不可用，用户不可购买，隐藏购买入口，底部提示“您还不符合购买要求”
  //       2.2.1.1 有普通卡，选择匹配的普通卡中的第一张卡，标签提示“限 XX 会员卡 用户购买”
  //       2.2.1.2 只有等级卡，选择匹配的最高等级卡，例如（用户拥有A卡LV1，LV2；B卡LV3，则选择B卡LV3）标签提示“限 B卡 LV3 以上等级购买”（B卡 LV3 是相应等级卡的名称）（等级相同的话选默认匹配的第一张等级卡）
  //     2.2.2 匹配卡部分/全部可用，用户可购买
  //       2.2.2.1 可用卡中有等级卡，同 2.2.1.2
  //       2.2.2.2 可用卡中只有普通卡，同 2.2.1.1
  static checkGroupBuyAuth = (data: any) => {
    if (!data) return {}
    let groupBuyEnable = true
    let groupBuyOnlyTip = ''
    const { isAllMember, cards: couponCardIds } = data
    const { cardList: mCardList } = memberMobx
    const { allCardList, brandLevelCardList, brandLevelCardMap, brandLevelOneCardIds } = memberCardMobx
    try {
      // step1
      if (isAllMember || isAllMember === undefined) {
        return { groupBuyEnable, groupBuyOnlyTip }
      }

      // step2
      const matchedMCards = [] // 匹配上的用户的会员卡列表
      const unMatchedMCards = [] // 没匹配上的用户的会员卡列表
      mCardList?.forEach(item => {
        const card = {
          cardId: item?.card?.cardId,
          cardName: item?.card?.cardName,
          status: item?.status
        }
        if (couponCardIds?.includes(card?.cardId)) {
          matchedMCards.push(card)
        } else {
          unMatchedMCards.push(card)
        }
      })
      const couponCommonCards = [] // 优惠券关联的普通会员卡列表
      const couponVipCards = [] // 优惠券关联的vip会员卡列表
      const couponVipCardMap = {} // 优惠券关联的vip会员卡map
      allCardList?.forEach((card: any) => {
        if (couponCardIds?.includes(card?.cardId)) {
          const cardItem = {
            cardId: card.cardId,
            cardName: card.cardName,
            sttaus: card.status
          }
          if (this.checkIsLevelCard(card?.cardId)) {
            couponVipCards.push(cardItem)
            couponVipCardMap[card.cardId] = {
              [card.cardId]: {
                cardId: card.cardId,
                cardName: card.cardName,
                level: 1
              }
            }
          } else {
            couponCommonCards.push(cardItem)
          }
        }
      })
      brandLevelCardList?.forEach((card: any) => {
        if (couponCardIds?.includes(card?.cardId)) {
          couponVipCards.push({
            cardId: card.cardId,
            cardName: card.cardName,
            staus: card.status
          })
          const parentId = this.checkIsLevelCard(card?.cardId)
          if (parentId) {
            if (!couponVipCardMap[parentId]) {
              couponVipCardMap[parentId] = {}
            }
            couponVipCardMap[parentId][card.cardId] = {
              cardId: card.cardId,
              cardName: card.cardName,
              level: brandLevelCardMap[card.cardId]?.level || 0
            }
          }
        }
      })

      // step 2.1 用户会员卡中无匹配卡
      if (matchedMCards.length === 0) {
        groupBuyEnable = false
        // step 2.1.1 有普通会员卡则直接取第一张
        if (couponCommonCards.length > 0) {
          return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.commonMCardEnable', { memberCard: couponCommonCards[0]?.cardName || '' }) }
        }
        // step 2.1.2.1
        let highestLevelCard = null
        // 用户未匹配上的中间等级卡最近的更高等级卡
        unMatchedMCards.forEach(card => {
          const parentId = this.checkIsLevelCard(card.cardId)
          if (parentId && !!couponVipCardMap[parentId]) { // 用户等级会员卡和优惠券等级会员卡属于同一系列的卡
            const couponLevelCards: any[] = this.getSortedLevelList(couponVipCardMap[parentId])
            const higherCard = couponLevelCards.find(levelCard => levelCard.level > (brandLevelCardMap?.[card?.cardId]?.level || 1))
            console.log('couponLevelCards', deepClone(couponLevelCards))
            if (!highestLevelCard || highestLevelCard?.level > higherCard?.level) {
              highestLevelCard = higherCard
            }
          }
        })
        if (highestLevelCard) {
          return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.vipMCardEnable', { memberCard: highestLevelCard?.cardName || '' }) }
        }
        // step 2.1.2.2
        let lowestLevelCard = null
        Object.values(couponVipCardMap).forEach(vipLevelCard => {
          const couponLeveCards: any[] = this.getSortedLevelList(vipLevelCard)
          if (!lowestLevelCard || lowestLevelCard.level > couponLeveCards[0]?.level) {
            lowestLevelCard = couponLeveCards[0]
          }
        })
        return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.vipMCardEnable', { memberCard: lowestLevelCard?.cardName || '' }) }
      }
      // step 2.2 用户会员卡中有匹配卡
      const matchedLevelMCards = [] // 匹配的等级会员卡
      const matchedCommonMCards = [] // 匹配的普通会员卡
      const matchedEnableLevelMCards = [] // 匹配的可用的等级会员卡
      const matchedEnableCommonMCards = [] // 匹配的可用的普通会员卡
      matchedMCards?.forEach(card => {
        if (this.checkIsLevelCard(card.cardId)) {
          matchedLevelMCards.push(card)
          if (card.status === 'enable') {
            matchedEnableLevelMCards.push(card)
          }
        } else {
          matchedCommonMCards.push(card)
          if (card.status === 'enable') {
            matchedEnableCommonMCards.push(card)
          }
        }
      })
      // step 2.2.1 匹配卡都不可用
      if (matchedEnableCommonMCards.length === 0 && matchedEnableLevelMCards.length === 0) {
        groupBuyEnable = false
        // step 2.2.1.1
        if (matchedCommonMCards.length) {
          return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.commonMCardEnable', { memberCard: matchedCommonMCards?.[0].cardName || '' }) }
        }
        // step 2.2.1.2
        let highestLevelCard = null
        matchedLevelMCards.forEach(card => {
          const cardLevel = brandLevelCardMap?.[card?.cardId]?.level || 1
          if (!highestLevelCard || highestLevelCard.level < cardLevel) {
            highestLevelCard = {
              ...card,
              level: cardLevel
            }
          }
        })
        return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.vipMCardEnable', { memberCard: highestLevelCard?.cardName || '' }) }
      }

      // step 2.2.2 匹配卡部分/全部可用
      // step 2.2.2.1
      if (matchedEnableLevelMCards.length > 0) {
        let highestLevelCard = null
        matchedEnableLevelMCards.forEach(card => {
          const cardLevel = brandLevelCardMap?.[card?.cardId]?.level || 1
          if (!highestLevelCard || (highestLevelCard.level < cardLevel)) {
            highestLevelCard = {
              ...card,
              level: cardLevel
            }
          }
        })
        return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.vipMCardEnable', { memberCard: highestLevelCard?.cardName || '' }) }
      }
      return { groupBuyEnable, groupBuyOnlyTip: i18n.t('mkt.redeem.commonMCardEnable', { memberCard: matchedEnableCommonMCards?.[0].cardName || '' }) }
    } catch (error) {
      console.error(error)
      return { groupBuyEnable }
    }
  }
}
